export const CATERING_PRODUCTS_PT_BR = {
	title: "Catering",
	description:
		"Listagem e configuração de itens usados nas propostas de serviços de Catering.",
	addProduct: "Adicionar produto",
	addCombo: "Adicionar combo",
	addMenu: {
		standalone: "Único / montável",
		combo: "Combo",
	},
	searchPlaceholder: "Pesquisar produto",
	allCategories: "Todas as categorias",
	tabs: {
		products: "Produtos",
		combos: "Combos",
		standalone: "Padrão",
		mountable: "Montáveis",
	},
	table: {
		product: "PRODUTO",
		category: "CATEGORIA",
		type: "TIPO",
		price: "PREÇO",
	},
	emptyState: "Nenhum produto encontrado",
	priceEdit: {
		validation: {
			pricePositive: "O preço deve ser um valor positivo",
			maxValue: "O preço não deve exceder o valor máximo permitido (21.474.836,47)",
		},
		changeModal: {
			title: "Alterar preço do produto",
			description:
				"Você está alterando o preço do produto <strong>{{productName}}</strong> para <strong>{{price}}</strong>.",
			secondParagraph:
				"Antes de sair da edição do preço, confirme se deseja continuar com a alteração ou cancelar.",
		},
		invalidModal: {
			title: "Valor inválido",
			description:
				"O valor inserido não é válido. O preço anterior do produto será mantido.",
		},
	},
	productForm: {
		tabs: {
			details: "Detalhes do produto",
			mountable: "Produto montável",
		},
		mountableLocked: "Para adicionar produtos montáveis, crie um produto novo.",
		save: "Salvar produto",
		sections: {
			generalInfo: {
				title: "Detalhes do produto",
				subtitle: "Informações gerais e precificação",
				imageAriaLabel: "Imagem do produto",
				imageSubtitle:
					"Clique ou arraste a imagem. A dimensão recomendada é de 500 x 500 pixels.",
				fields: {
					name: {
						label: "Nome",
						placeholder: "Nome do produto",
					},
					category: {
						label: "Categoria",
						placeholder: "Bebida",
					},
					price: {
						label: "Preço (opcional)",
						placeholder: "00,00",
					},
				},
			},
			mountable: {
				title: "Produto montável",
				subtitle:
					"Os produtos montáveis permitem que o cliente final faça uma combinação a partir de uma base fixa e uma variedade de ingredientes adicionais.",
				stepLabel: "Etapa",
				addStep: "Etapa",
				removeStep: "Remover etapa",
				fields: {
					title: {
						label: "Título",
						placeholder: "Digite o título da etapa",
					},
					pricing: {
						label: "Precificação",
						placeholder: "Escolha um método",
						options: {
							sum: "Somar",
							average: "Média",
							higher: "Maior",
						},
					},
					min: {
						label: "Valor mínimo",
						placeholder: "00,00",
					},
					max: {
						label: "Valor máximo",
						placeholder: "00,00",
					},
				},
				items: {
					title: "Ingredientes adicionais",
					addItem: "Adicionar outro item",
					removeItem: "Remover item",
					fields: {
						product: {
							label: "Item",
							placeholder: "Selecione um item",
						},
						price: {
							label: "Valor",
							placeholder: "00,00",
						},
						maxCount: {
							label: "Quantidade máxima selecionável",
							placeholder: "Digite a quantidade",
						},
						storageCount: {
							label: "Quantidade abatida",
							placeholder: "0",
						},
					},
				},
			},
		},
		validation: {
			name: {
				required: "Informe o nome do produto",
				min: "O nome deve ter no mínimo 3 caracteres",
				max: "O nome deve ter no máximo 100 caracteres",
			},
			category: {
				required: "Selecione uma categoria",
			},
			value: {
				required: "Informe o preço",
				invalid: "Preço inválido",
				min: "O preço deve ser um valor positivo",
				max: "O preço não deve exceder o valor máximo permitido",
			},
			mountable: {
				sections: {
					required: "Adicione ao menos 1 etapa",
				},
				title: {
					required: "Informe o título da etapa",
				},
				pricing: {
					required: "Selecione uma regra de preço",
					invalid: "Regra de preço inválida",
				},
				max: {
					min: "O máximo deve ser ao menos 1",
					greaterThanMin: "O máximo deve ser maior ou igual ao mínimo",
				},
				items: {
					required: "Adicione ao menos 1 item na etapa",
				},
				item: {
					productId: {
						required: "Selecione um produto",
						duplicate: "Produto duplicado na mesma etapa",
					},
					price: {
						min: "O preço do item deve ser positivo",
						max: "Valor máximo excedido",
					},
					storageCount: {
						min: "Quantidade em estoque deve ser ao menos 1",
						max: "Valor máximo excedido",
					},
				},
			},
		},
	},
};

export type CateringProductsTranslations = typeof CATERING_PRODUCTS_PT_BR;
